
import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, Heart, Calendar } from "lucide-react";
import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import LanguageSwitcher from "./LanguageSwitcher";
import { useLanguage } from "@/contexts/LanguageContext";

const Navbar = ({
  activePage
}: {
  activePage?: string;
}) => {
  const { language } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [sheetOpen, setSheetOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = {
    fr: {
      calendarButtonText: "Démarrer avec un conseiller"
    },
    en: {
      calendarButtonText: "Start with an advisor"
    },
    de: {
      calendarButtonText: "Mit einem Berater beginnen"
    }
  };

  const handleCalendlyClick = () => {
    window.location.href = "https://calendly.com/legatia/15min";
  };

  const content = navItems[language];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-white/98 backdrop-blur-lg shadow-md border-b border-gray-100" : "bg-transparent"}`}>
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2.5 group" onClick={() => window.scrollTo(0, 0)}>
          <div className="w-9 h-9 rounded-full bg-legatia-green/10 flex items-center justify-center group-hover:bg-legatia-green/20 transition-all duration-200 group-hover:scale-105">
            <Heart className="h-4.5 w-4.5 text-legatia-green" />
          </div>
          <span className="text-xl md:text-2xl font-semibold text-legatia-green">Legatia</span>
        </Link>
        
        <div className="hidden md:flex items-center gap-3">
          <LanguageSwitcher />
          
          <Button 
            className="bg-legatia-green hover:bg-legatia-green/90 text-white rounded-full shadow-sm hover:shadow-lg transition-all hover:scale-105 gap-2" 
            onClick={handleCalendlyClick}
          >
            <Calendar className="h-4 w-4" />
            {content.calendarButtonText}
          </Button>
        </div>
        
        <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon">
              <Menu className="h-5 w-5" />
            </Button>
          </SheetTrigger>
          <SheetContent className="w-[280px]">
            <div className="flex flex-col gap-6 mt-8">
              <div className="flex items-center gap-2 pb-6 border-b">
                <div className="w-8 h-8 rounded-full bg-legatia-green/10 flex items-center justify-center">
                  <Heart className="h-4 w-4 text-legatia-green" />
                </div>
                <span className="text-xl font-semibold text-legatia-green">Legatia</span>
              </div>
              
              <LanguageSwitcher />
              
              <Button 
                className="bg-legatia-green hover:bg-legatia-green/90 text-white w-full gap-2" 
                onClick={() => {
                  handleCalendlyClick();
                  setSheetOpen(false);
                }}
              >
                <Calendar className="h-4 w-4" />
                {content.calendarButtonText}
              </Button>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </nav>
  );
};

export default Navbar;
